const animationManagingContentEffect = () => {
	const container = document.querySelector('.managing-container');

	if (container) {
		const elements = container.querySelectorAll('.managing-content > *'),
			content = container.querySelector('.managing-content'),
			aside = container.querySelector('.managing-aside');

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: container,
				start: 'top+=10% bottom',
				//markers: true,
			},
		});

		tl.from(content, {
			duration: 0.6,
			left: '-=100%',
			ease: 'power1.out',
		});

		if (elements.length) {
			tl.from(elements, {
				duration: 0.3,
				autoAlpha: 0,
				y: 40,
				ease: 'power1.out',
				stagger: 0.15,
			});
		}

		if (aside) {
			gsap.from(aside, {
				scrollTrigger: {
					trigger: aside,
					start: `top+=15% bottom`,
					//markers: true
				},
				duration: 0.5,

				autoAlpha: 0,
				y: 40,
				ease: 'power2.in',
			});
		}
	}
};

export default animationManagingContentEffect;
